import React, { useEffect, useReducer, useMemo, useContext } from "react";
import request from "../../utils/request";
import df from "../../utils/dateFormater";
import _ from "lodash";
import { getSession, getUserId, getDist } from "../../utils/sessionHandler";
import moment from "moment";

import useStyles from "./CavitestLiveStyles";
import t from "../../utils/translation";
import LocalizationContext from "../../utils/LocalizationContext";

import CRUD from "../../components/CRUD";
import PageContentLoading from "../../components/PageContentLoading";
import Modal from "../../components/Modal";
import CircularProgress from "../../components/CircularProgress";
import GroupedDetail from "../../components/GroupedDetail/GroupedDetail";
import reducer from "./CavitestLiveReducer";
import { flatten } from "flat";

const isAspTheme = JSON.parse(localStorage.getItem("__dist"))?.themeFileName === "aspTheme";

const formatSelectObjectProd = (objectData, emptyText) => {
    return objectData.reduce(
        (objectsList, object) => {
            objectsList.push([object.id, object.description || object.toString, object.productModel]);
            return objectsList;
        },
        [[null, emptyText]]
    );
};

const initialState = {
    products: [],
    possibleResults: [],
    loadingContent: true,
    loadingData: false,
    pagination: { Page: 1, PageSize: 10 },
    requiredFields: [],
    data: [],
    detailObject: null,
    loadingDetail: false,
    formFields: [],
    detailFields: [],
    lastTimeUpdated: undefined,
    groups: [
        { Description: t("ProductGroup"), position: 1, Index: 0, visible: true },
        { Description: t("IncubationGroup"), position: 0, Index: 1, visible: true },
        { Description: t("OtherGroup"), position: 2, Index: 2, visible: true },
    ],
    indexProductGroup: 0,
    indexIncubationGroup: 1,
    indexOtherGroup: 2,
};

const CavitestLive = () => {
    const classes = useStyles();
    const locale = useContext(LocalizationContext);
    const [state, dispatch] = useReducer(reducer, initialState);

    const getLive = (
        Pagination = { Page: state.pagination.Page, PageSize: state.pagination.PageSize, OrderBy: null, OrderType: null }
    ) => {
        dispatch({ type: "SET_PAGINATION", payload: { pagination: Pagination } });
        updateData();
    };

    useEffect(() => {
        Promise.all([
            request().get(`/api/Product/GetByDistributorEncrypted?distributorId=${getDist().id}`),
            request().get("/api/ReadingCavitest/GetPossibleResults"),
            request().get(`/api/Screen/GetRequiredFields?Screen=600`),
        ])
            .then(([productsData, possibleResultsData, requiredFields]) => {
                setTimeout(() => {
                    dispatch({
                        type: "SET_CONTENT",
                        payload: {
                            products: formatSelectObjectProd(productsData.data, t("ChooseAProductText", locale)),
                            possibleResults: possibleResultsData.data,
                            requiredFields: requiredFields.data,
                        },
                    });
                }, 250);
            })
            .catch((error) => console.log(error.response));
    }, [locale]);

    useEffect(() => {
        if (!state.loadingContent) {
            setupFormFields();
            updateData();
        }
    }, [state.loadingContent]);

    const secondsToString = (seconds) => {
        var hour = Math.floor(seconds / 3600);
        hour = hour < 10 ? "0" + hour : hour;
        var minute = Math.floor((seconds / 60) % 60);
        minute = minute < 10 ? "0" + minute : minute;
        var second = seconds % 60;
        second = second < 10 ? "0" + second : second;
        return hour + ":" + minute + ":" + second;
    };

    const updateData = () => {
        dispatch({ type: "TOGGLE_LOADING_DATA" });
        request()
            .get(`/api/ReadingCavitest/getlive?UserLoggedId=${getUserId()}`)
            .then((response) => {
                const today = new Date();
                dispatch({
                    type: "SET_DATA",
                    payload: {
                        lastTimeUpdated: df(today, "dateTime"),
                        data: response.data
                            .reduce((readingsList, reading) => {
                                readingsList.push({
                                    ...reading,
                                    startTimeFormatted: df(reading.startedTime, "dateTime"),
                                    elapsedTime: secondsToString(
                                        moment(today.toISOString()).diff(
                                            moment.utc(reading.startedTime, "YYYY-MM-DD HH:mm:ss"),
                                            "seconds"
                                        )
                                    ),
                                    incubatorName: reading.incubator?.toString || "",
                                });
                                return readingsList;
                            }, [])
                            .map((x) =>
                                _.mapKeys(x, (value, key) => {
                                    return "ReadingCavitest." + key;
                                })
                            ),
                    },
                });
                setTimeout(() => {
                    dispatch({ type: "TOGGLE_LOADING_DATA" });
                }, 250);
            })
            .catch((error) => console.log(error.response));
    };

    const setupFormFields = () => {
        dispatch({
            type: "SET_FORM_FIELDS",
            payload: {
                formFields: formFieldsDefinition(),
                detailFields: detailFieldsDefinition,
            },
        });
    };

    const formFieldsDefinition = () => [
        {
            position: 0,
            groupIndex: state.indexProductGroup,
            label: t("ProductLabel", locale),
            propOnObject: "ReadingCavitest.productId",
            propOnMassiveObject: "ReadCavitestMasive.productId",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1225) ? true : false,
            type: "select",
            options: state.products,
        },
        {
            position: 1,
            groupIndex: state.indexProductGroup,
            label: t("LoteProductLabel", locale),
            propOnObject: "ReadingCavitest.loteProduct",
            propOnMassiveObject: "ReadCavitestMasive.loteProduct",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1235) ? true : false,
        },
        {
            position: 0,
            groupIndex: state.indexOtherGroup,
            label: t("BookNumberLabel", locale),
            propOnObject: "ReadingCavitest.bookNumber",
            propOnMassiveObject: "ReadCavitestMasive.bookNumber",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1285) ? true : false,
        },
        {
            position: 1,
            groupIndex: state.indexOtherGroup,
            label: t("PageNumberLabel", locale),
            propOnObject: "ReadingCavitest.pageNumber",
            propOnMassiveObject: "ReadCavitestMasive.pageNumber",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1295) ? true : false,
        },
        ...(!isAspTheme
            ? [
                  {
                      position: 2,
                      groupIndex: state.indexOtherGroup,
                      label: t("ReferenceSpan") || "Reference",
                      propOnObject: "ReadingCavitest.reference",
                      propOnMassiveObject: "ReadCavitestMasive.reference",
                      class: "col-12 col-md-6 px-0",
                      required: false,
                  },
              ]
            : []),
        {
            position: 3,
            groupIndex: state.indexOtherGroup,
            label: t("ProgramNumberLabel", locale),
            propOnObject: "ReadingCavitest.programNumber",
            propOnMassiveObject: "ReadCavitestMasive.programNumber",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1297) ? true : false,
        },
        {
            position: 4,
            groupIndex: state.indexOtherGroup,
            label: t("NotesLabel", locale),
            propOnObject: "ReadingCavitest.notes",
            propOnMassiveObject: "ReadCavitestMasive.notes",
            class: "col-12 col-md-6 px-0",
            required: state.requiredFields?.find((x) => x.objectName === 1345) ? true : false,
        },
    ];

    const detailFieldsDefinition = useMemo(
        () => [
            // Product group
            { label: t("ProductLabel", locale), name: "product.toString", position: 0, groupIndex: state.indexProductGroup },
            { label: t("LoteProductLabel", locale), name: "loteProduct", position: 1, groupIndex: state.indexProductGroup },
            // Incubation group
            { label: t("UserLabel", locale), name: "appUser.toString", position: 0, groupIndex: state.indexIncubationGroup },
            { label: t("SectorLabel", locale), name: "sector.toString", position: 1, groupIndex: state.indexIncubationGroup },
            { label: t("PositionNumberLabel", locale), name: "positionNumber", position: 2, groupIndex: state.indexIncubationGroup },
            { label: t("StartTimeLabel", locale), name: "startedTime", type: "dateTime", position: 3, groupIndex: state.indexIncubationGroup },
            { label: t("IncubatorLabel", locale), name: "incubator.toString", position: 4, groupIndex: state.indexIncubationGroup },
            // Other group
            { label: t("BookNumberLabel", locale), name: "bookNumber", position: 0, groupIndex: state.indexOtherGroup },
            { label: t("PageNumberLabel", locale), name: "pageNumber", position: 1, groupIndex: state.indexOtherGroup },
            ...(!isAspTheme ? [{ label: t("ReferenceSpan") || "Reference", name: "reference", position: 2, groupIndex: state.indexOtherGroup }] : []),
            { label: t("ProgramNumberLabel", locale), name: "programNumber", position: 3, groupIndex: state.indexOtherGroup },
            { label: t("NotesLabel", locale), name: "notes", position: 4, groupIndex: state.indexOtherGroup },
        ],
        [locale]
    );

    const columnsCollections = [
        { name: "ReadingCavitest.readNumber", canOrder: true },
        { name: "ReadingCavitest.positionNumber", canOrder: true },
        ...(!isAspTheme ? [{ name: "ReadingCavitest.reference", canOrder: true }] : []),
        { name: "ReadingCavitest.startTimeFormatted", canOrder: true },
        { name: "ReadingCavitest.elapsedTime", canOrder: true },
        { name: "ReadingCavitest.incubatorName", canOrder: true },
    ];

    const headersCollections = useMemo(
        () => [
            t("ReadNumberLabel", locale),
            t("PositionNumberLabel", locale),
            ...(!isAspTheme ? [t("ReferenceSpan")] : []),
            t("StartTimeLabel", locale),
            t("ElapsedTimeLabel", locale),
            t("IncubatorLabel", locale),
        ],
        [locale]
    );

    const getDetail = (r) => {
        dispatch({ type: "SET_DETAIL_OBJECT", payload: { detailObject: null, loadingDetail: true } });
        request()
            .get(`/api/ReadingCavitest/getdetail?Id=${r["ReadingCavitest.id"]}`)
            .then((response) => {
                setTimeout(() => {
                    const row = state.data.find((x) => x["ReadingCavitest.id"] === response.data.id);
                    if (row) row["ReadingCavitest.viewed"] = true;
                    dispatch({
                        type: "SET_DETAIL_OBJECT",
                        payload: { detailObject: flatten(response.data), data: state.data, loadingDetail: false },
                    });
                }, 500);
            });
    };

    const baseObject = useMemo(
        () => ({
            UserLogged: getSession(),
        }),
        [locale]
    );

    const massiveBaseObject = useMemo(
        () => ({
            ReadCavitestMasive: {
                ReadIds: [],
                productId: null,
                loteProduct: "",
                bookNumber: "",
                pageNumber: "",
                reference: "",
                programNumber: "",
                notes: "",
            },
            UserLogged: getSession(),
        }),
        [locale]
    );

    if (state.loadingContent) return <PageContentLoading />;

    return (
        <div>
            <CRUD
                counterDown={{
                    initialMinute: 0,
                    initialSeconds: 30,
                    refresh: updateData,
                    onceTime: false,
                }}
                loadingData={state.loadingData}
                newOption={false}
                detailOption={false}
                deleteOption={false}
                multiSelect={true}
                data={state.data}
                order={{ dir: "desc", orderBy: "ReadingCavitest.readNumber" }}
                url={"/api/ReadingCavitest"}
                massiveURL={"/api/ReadingCavitest/masiveModify"}
                title={t("CavitestTitle", locale) || "Cavitest"}
                tableHeader={`${t("CavitestLiveTitle", locale) || "Cavitest Live"} ${state.lastTimeUpdated || ""}`}
                viewedMark={true}
                onEditClick={() => {
                    setupFormFields();
                }}
                onEditMassiveButtonClick={() => {
                    setupFormFields();
                }}
                tableActions={[
                    {
                        icon: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z",
                        tooltip: t("DetailTooltip"),
                        action: getDetail,
                    },
                ]}
                updateData={() => getLive(state.pagination)}
                columns={columnsCollections}
                headers={headersCollections}
                idField={"ReadingCavitest.id"}
                grouped={state.groups}
                useFieldMap={false}
                formFields={state.formFields}
                baseObject={baseObject}
                massiveBaseObject={massiveBaseObject}
                method={"put"}
            />

            {(state.loadingDetail || state.detailObject) && (
                <Modal
                    header={
                        <div className={classes.header}>
                            <div className={classes.headerText}>{`${t("CavitestTitle", locale) || "Cavitest"} ${
                                state.detailObject ? `(${state.detailObject.readNumber})` : ""
                            }`}</div>
                            <span
                                className={classes.modalCloseButton}
                                onClick={() => dispatch({ type: "SET_DETAIL_OBJECT", payload: { detailObject: null } })}
                            >
                                <svg viewBox="0 0 24 24">
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                            </span>
                        </div>
                    }
                    closeModal={() => dispatch({ type: "SET_DETAIL_OBJECT", payload: { detailObject: null } })}
                    responsive
                >
                    {!state.detailObject && (
                        <div className={classes.detailLoading}>
                            <CircularProgress />
                        </div>
                    )}
                    {state.detailObject && (
                        <GroupedDetail groups={state.groups} detailFields={state.detailFields} detailObject={state.detailObject} />
                    )}
                </Modal>
            )}
        </div>
    );
};

export default CavitestLive;
